var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DocumentList',{attrs:{"attachments":[_vm.document],"small":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }